export type PaymentMethodType = "card" | "boleto" | "pix" | "partnership";

// Métodos que o paciente escolhe no checkout. "partnership" é decidido pelo app.
export type AvailablePaymentMethod = Exclude<PaymentMethodType, "partnership">;

export const AVAILABLE_PAYMENT_METHODS: AvailablePaymentMethod[] = [
  "card",
  "boleto",
  "pix",
];
